var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.onSubmit}},[_vm._v("保存")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }